import { FormikErrors, FormikTouched } from "formik";
import { BLValues } from "../../../interfaces/bl-export/request.bl.interface";

export const handleTouchedCloneBl = (
  setTouched: (
    touched: FormikTouched<BLValues>,
    shouldValidate?: boolean | undefined
  ) => Promise<void> | Promise<FormikErrors<BLValues>>
) => {
  setTouched(
    {
      cod_booking: true,
      ocean_vessel: true,
      port_descharge: true,
      from: true,
      port_loading: true,
      place_delivery: true,
      bl_details: true,
      dae: true,
      formaPago: true,
      hs_code: true,
      info_consignee: true,
      info_notify: true,
      tipo_bl: true,
    },
    true
  );
};

export const handleTouchedBlCW1Fields = (
  setTouched: (
    touched: FormikTouched<BLValues>,
    shouldValidate?: boolean | undefined
  ) => Promise<void> | Promise<FormikErrors<BLValues>>
) => {
  setTouched(
    {
      cod_booking: true,
      ocean_vessel: true,
      port_descharge: true,
      from: true,
      port_loading: true,
      place_delivery: true,
      dae: true,
      tipo_bl: true,
      formaPago: true,
    },
    true
  );
};
